<form [formGroup]="fg" #form="ngForm">
    <section>
        <div class="group-section title-section">
            <h1 class="mat-headline-large">Contact person</h1>
        </div>


          <div class="group-section small-group">
            <p class="mat-body-large">Who is the contact person for this loan?</p>
            <div class="group-section">
              <app-form-field [formSubmitted]="form.submitted" label="First name" [control]="fg.controls.firstName">
              </app-form-field>              
              <app-form-field [formSubmitted]="form.submitted" label="Last name" [control]="fg.controls.lastName">
              </app-form-field>
            </div>
          </div>
          
        <div class="group-section">
            <app-form-field [formSubmitted]="form.submitted" label="Mobile phone" [control]="fg.controls.mobile" type="tel">
            </app-form-field>

            <app-form-field [formSubmitted]="form.submitted" label="Email address" [control]="fg.controls.email">
            </app-form-field>
        </div>
        <div>
            <button class="btn-next" mat-flat-button (click)="onButtonNext(fg, parentStepper)">Next</button>
        </div>
    </section>
</form>

